<template>
  <div id="invitation_l">
    <top></top>
    <div class="main">
      <div class="content">
        <div class="go-back" @click="goBack">返回</div>
        <p class="invitation_l_title">邀请函</p>
        <div class="invitation_l_border"></div>
        <div class="invitation_l_search">
          <div>
            <p>座位号</p>
            <el-input placeholder="请输入" v-model="seatNumber"></el-input>
          </div>
          <div>
            <p>邀请函类型</p>
            <el-select v-model="vip" placeholder="请选择">
              <el-option
                v-for="item in ticket_type_options"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <p>状态</p>
            <el-select v-model="useStatus" placeholder="请选择">
              <el-option
                v-for="item in is_use_options"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="invitation_l_search_button" @click="getInvitationData">
            搜索
          </div>
        </div>
        <div class="invitation_l_border second"></div>
        <div class="invitation_l_button">
          <div class="declare_fillButton" @click="toAddInvitation">新建</div>
        </div>
        <div class="invitation_l_table">
          <el-table :data="invitation_table_data" stripe style="width: 100%">
            <el-table-column
              prop="invitation_code"
              label="邀请码"
              min-width="240"
            >
            </el-table-column>
            <el-table-column prop="venue_name" label="活动名称" min-width="240">
            </el-table-column>
            <el-table-column prop="seat_number" label="座位号" min-width="120">
            </el-table-column>
            <el-table-column
              prop="ticket_type_characters"
              label="VIP"
              min-width="100"
            ></el-table-column>
            <el-table-column
              prop="is_use_characters"
              label="状态"
              min-width="100"
            ></el-table-column>
            <el-table-column
              prop="consumer"
              label="使用人"
              min-width="120"
            ></el-table-column>
            <el-table-column
              prop="consumer_mobile"
              label="电话"
              min-width="150"
            ></el-table-column>
            <el-table-column label="是否显示座位号" min-width="120">
              <template slot-scope="scope">
                {{ scope.row.is_show_seat == 1 ? "是" : "否" }}
              </template>
            </el-table-column>
            <el-table-column label="邀请函" min-width="100">
              <template slot-scope="scope">
                <div
                  class="invitation_l_table_download declare_fillButton"
                  :class="{ disabled: scope.row.is_use == 1 }"
                  @click="downloadInvitation(scope.row)"
                >
                  下载
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="100">
              <template slot-scope="scope">
                <span
                  style="
                    font-size: 14px;
                    color: #1677ff;
                    cursor: pointer;
                    margin-right: 10px;
                  "
                  @click="toModifyInvitation(scope.row.id)"
                  >编辑</span
                >
                <span
                  style="font-size: 14px; color: #ff2828; cursor: pointer"
                  @click="handleDeleteInvitation(scope.row.id)"
                  >删除</span
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="invitation_l_pagination">
          <el-pagination
            :current-page="currentPage"
            :page-size="pageSize"
            @current-change="changeCurrentPage"
            background
            layout="prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!--  v-if="showInvitation"   -->
    <div ref="invitation" class="invitation_content">
      <img class="invitation_bg" :src="invitationData.cover_image" alt="" />
      <img
        class="invitation_bg_mask"
        src="https://oss.indata3.com/cfa/uploads/images/20260819/a0bd7f03191d8cc286c7b01525b9b28b.png"
        alt=""
        v-show="showCustomizationModel"
      />
      <div class="content_box">
        <p class="invitation_invitee" v-if="invitationData.invitation_name">
          尊敬的<span>{{ invitationData.invitation_name }}</span
          >先生/女士
        </p>
        <p class="invitation_invitee" v-else>尊敬的来宾</p>
        <p class="invitation_text">诚挚邀请您出席</p>
        <p class="invitation_title">{{ invitationData.venue_name }}</p>
        <p class="invitation_subtitle">日期<span>|</span>DATE</p>
        <p class="invitation_date">
          {{ invitationData.week_str }}<span>{{ invitationData.day_str }}</span
          >{{ invitationData.week_en_str }}
        </p>
        <p class="invitation_subtitle">地点<span>|</span>LOCATION</p>
        <p class="invitation_location">{{ invitationData.location }}</p>
        <p class="invitation_line"></p>
        <div class="invitation_footer" v-if="invitationData.is_show_seat == 1">
          <div>
            <p class="invitation_key">座位号码</p>
            <p
              class="invitation_value"
              v-if="invitationData.is_show_seat !== 0"
            >
              {{ invitationData.seat_number }}
            </p>
            <p class="invitation_value" v-else>——</p>
          </div>
          <div class="invitation_border"></div>
          <div>
            <p class="invitation_key">开场时间</p>
            <p class="invitation_value">{{ invitationData.hour_str }}</p>
          </div>
        </div>
        <div class="invitation_footer2" v-else>
          <div class="invitation_div">
            <div class="invitation_key">开场时间</div>
            <div class="invitation_value">{{ invitationData.hour_str }}</div>
          </div>
        </div>
        <p class="invitation_line"></p>
      </div>
      <div class="qrcode_box">
        <img :src="invitationQRcodeUrl + invitationData.qr_code_img" alt="" />
      </div>
    </div>
    <maskLayer
      :show="showLayer"
      :type="'upload'"
      :text="'正在下载中'"
    ></maskLayer>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import maskLayer from "../../components/maskLayer.vue";
import html2canvas from "html2canvas";
import {
  getDictionary,
  getInvitationList,
  deleteInvitation,
} from "../../api/api";
export default {
  name: "invitationList",
  components: { top, maskLayer },
  data() {
    return {
      invitationQRcodeUrl: "https://cfa.fashion.org.cn/",
      activityId: "",
      seatNumber: "",
      vip: "",
      useStatus: "",
      ticket_type_options: [],
      is_use_options: [],
      invitation_table_data: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      invitationData: {},
      invitation_logo: require("../../assets/logo.png"),
      showInvitation: false,
      showLayer: false,
      showCustomizationModel: false,
    };
  },
  created() {
    this.activityId = this.$route.query.id;
    this.getDict();
  },
  methods: {
    async getDict() {
      let dictionaryString = "?type=ticket_type,is_use";
      const res = await getDictionary(dictionaryString);
      if (res.code == 1) {
        this.ticket_type_options = res.data.ticket_type;
        this.is_use_options = res.data.is_use;
        this.getInvitationData();
      } else {
        this.$message.error(res.msg);
      }
    },
    async getInvitationData() {
      let data = {
        activities_id: this.activityId,
        page_no: this.currentPage,
        page_size: this.pageSize,
        seat_number: this.seatNumber,
        ticket_type: this.vip,
        is_use: this.useStatus,
      };
      const res = await getInvitationList(this.$qs.stringify(data));
      if (res.code == 1) {
        this.total = res.data.count;
        res.data.lists.forEach((item) => {
          for (let i = 0; i < this.ticket_type_options.length; i++) {
            if (this.ticket_type_options[i].value == item.ticket_type) {
              item.ticket_type_characters = this.ticket_type_options[i].name;
            }
          }
          for (let j = 0; j < this.is_use_options.length; j++) {
            if (this.is_use_options[j].value == item.is_use) {
              item.is_use_characters = this.is_use_options[j].name;
            }
          }
        });
        this.invitation_table_data = res.data.lists;
      } else {
        this.$message.error(res.msg);
      }
    },
    toAddInvitation() {
      this.$router.push({
        path: "/newInvitation",
        query: {
          activityId: this.activityId,
          mode: "add",
        },
      });
    },
    toModifyInvitation(id) {
      this.$router.push({
        path: "/newInvitation",
        query: {
          activityId: this.activityId,
          invitationId: id,
          mode: "edit",
        },
      });
    },
    handleDeleteInvitation(id) {
      this.$confirm("请问您确定要删除该邀请函吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deleteInvitation({
            activities_id: this.activityId,
            id,
          });
          if (res.code == 1) {
            this.$message.success(res.msg);
            if ((Number(this.total) - 1) % 10 === 0 && this.currentPage != 1) {
              this.currentPage = this.currentPage - 1;
            }
            this.getInvitationData();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async downloadInvitation(row) {
      if (row.is_use == 1) {
        return false;
      }
      // this.showLayer = true;
      this.showInvitation = true;
      this.showCustomizationModel = row.cover_type == 2;
      this.invitationData = row;
      try {
        await this.$nextTick();
        const element = this.$refs.invitation;
        const canvas = await html2canvas(element, {
          useCORS: true,
          allowTaint: true,
          scale: 4,
          backgroundColor: null,
          logging: false,
          letterRendering: true,
        });
        const imageUrl = canvas.toDataURL("image/png", 1.0);
        const link = document.createElement("a");
        link.href = imageUrl;
        link.download = this.invitationData.seat_number;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.invitationData = {};
        this.showCustomizationModel = false;
        this.showLayer = false;
        this.showInvitation = false;
      } catch (error) {
        this.$message.error("下载邀请函失败，请联系管理员");
        this.showCustomizationModel = false;
        this.showLayer = false;
        this.showInvitation = false;
      }
    },
    changeCurrentPage(val) {
      this.currentPage = val;
      this.getInvitationData();
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.invitation_l_title {
  font-size: 18px;
  font-weight: 700;
  color: #333;
  margin-top: 20px;
}
.invitation_l_border {
  width: 100%;
  height: 5px;
  background-color: #f3f3f3;
  margin: 20px 0;
}
.invitation_l_border.second {
  margin-top: 32px;
}
.invitation_l_search {
  display: flex;
  > div {
    width: 20%;
    margin-right: 2%;
    p {
      font-size: 14px;
      line-height: 22px;
      font-size: 14px;
      color: #7f8fa4;
      margin-bottom: 8px;
    }
    /deep/ .el-input {
      height: 36px;
      .el-input__inner {
        height: 100%;
        border-radius: 8px;
      }
    }
  }
  .invitation_l_search_button {
    width: 102px;
    height: 36px;
    background-color: #e40080;
    color: #fff;
    text-align: center;
    line-height: 36px;
    font-size: 14px;
    border-radius: 8px;
    margin-top: auto;
    cursor: pointer;
  }
  .invitation_l_search_button:hover {
    opacity: 0.8;
  }
}
.invitation_l_button {
  display: flex;
  margin-bottom: 20px;
  div {
    width: 104px;
    height: 36px;
    line-height: 36px;
    margin-right: 20px;
  }
}
.invitation_l_table {
  .invitation_l_table_download {
    width: 56px;
    height: 24px;
    line-height: 24px;
    font-size: 12px;
    background-color: #e40080;
  }
  .invitation_l_table_download.disabled {
    background-color: #adb4c7;
    cursor: no-drop;
  }
}
.invitation_l_pagination {
  /deep/ .el-pagination {
    box-sizing: border-box;
    padding-right: 60px;
    text-align: right;
    margin-top: 100px;
  }
}

.invitation_content {
  width: 360px;
  height: 640px;
  overflow: hidden;
  left: -1000px;
  // top: 200px;
  // left: 500px;
  //position: relative;
  position: absolute;
  box-sizing: border-box;
  z-index: 999;
  .invitation_bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    z-index: 9;
  }
  .invitation_bg_mask {
    position: absolute;
    top: 0px;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    z-index: 99;
  }
  .content_box {
    width: 280px;
    height: 336px;
    position: absolute;
    top: 190px;
    left: 50%;
    transform: translateX(-50%);
    box-sizing: border-box;
    padding: 0 20px;
    z-index: 999;
    .invitation_invitee {
      color: #fff;
      font-family: "Light", sans-serif;
      text-align: center;
      margin-top: 20px;
      span {
        font-family: "Bold", sans-serif;
        margin: 0 4px;
      }
    }
    .invitation_text {
      color: #fff;
      font-family: "Light", sans-serif;
      text-align: center;
      font-size: 12px;
      margin-top: 4px;
    }
    .invitation_title {
      white-space: pre-line;
      color: #fff;
      font-family: "Black", sans-serif;
      text-align: center;
      font-size: 18px;
      margin-top: 10px;
      line-height: 24px;
      margin-bottom: 20px;
    }
    .invitation_subtitle {
      color: #fff;
      font-family: "Light", sans-serif;
      text-align: center;
      font-size: 10px;
      margin-bottom: 8px;
      span {
        margin: 0 8px;
      }
    }
    .invitation_date {
      color: #fff;
      font-family: "Regular", sans-serif;
      text-align: center;
      font-size: 8px;
      margin-bottom: 20px;
      span {
        font-family: "Light", sans-serif;
        margin: 0 12px;
        font-size: 18px;
      }
    }
    .invitation_location {
      font-family: "Light", sans-serif;
      text-align: center;
      font-size: 18px;
      color: #fff;
      margin-bottom: 20px;
    }
    .invitation_line {
      background-color: rgba(255, 255, 255, 0.3);
      width: 200px;
      margin: 0 auto;
      height: 1px;
    }
    .invitation_footer {
      width: 200px;
      margin: 10px auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .invitation_border {
        width: 1px;
        height: 30px;
        background-color: rgba(255, 255, 255, 0.3);
      }
      .invitation_key {
        font-size: 10px;
        margin-bottom: 8px;
        color: #fff;
        font-family: "Light", sans-serif;
      }
      .invitation_value {
        font-size: 16px;
        color: #fff;
        font-family: "Light", sans-serif;
      }
    }

    .invitation_footer2 {
      width: 200px;
      margin: 5px auto;
      display: flex;
      align-items: center;
      justify-content: center;
      .invitation_div {
        height: 40px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .invitation_key {
          font-size: 16px;
          margin: 0;
          color: #fff;
          font-family: 'Light', sans-serif;
        }
        .invitation_value {
          font-size: 16px;
          margin: 0;
          color: #fff;
          font-family: 'Light', sans-serif;
        }
      }
    }


  }
  .qrcode_box {
    width: 280px;
    height: 70px;
    position: absolute;
    top: 540px;
    left: 50%;
    transform: translateX(-50%);
    box-sizing: border-box;
    z-index: 999;
    img {
      margin-left: 30px;
      margin-top: 10px;
      width: 50px;
      height: 50px;
    }
  }
}
</style>